export default __webpack_public_path__ + "static/media/item-1.6515fc3d.webp";